import Address from './Address';

class Reference {
	constructor(reference = {}) {
		this.applicantId = reference.applicantId || 0;
		this.currentAddress = new Address(reference);
		this.name = reference.name || '';
		this.phone = reference.phone || '';
		this.referenceType = reference.referenceType || '';
	}
}

export default Reference;
